import { Element } from 'react-scroll';
import { useTranslation } from 'react-i18next';
import { TbShieldCheck, TbWorld } from 'react-icons/tb';

import BrandMark from "src/components/brandMark/BrandMark";


const About = () => {
    const { t } = useTranslation("home");

    return (
        <Element name="aboutUs" className="relative overflow-hidden py-16 sm:py-24 lg:py-32">
            <div className="container">
                <div className="grid items-center gap-14 lg:grid-cols-12 lg:gap-16">

                    {/* Image */}
                    <div data-aos="fade-up" className="relative mx-auto w-full max-w-lg lg:col-span-5 lg:max-w-xl">
                        {/* decorative layers */}
                        <div aria-hidden className="absolute -start-3 -top-3 h-28 w-28 rounded-3xl text-primary-300 bg-dots sm:-start-6 sm:-top-6 sm:h-36 sm:w-36" />
                        <div aria-hidden className="absolute -bottom-3 -end-3 h-2/3 w-2/3 rounded-3xl bg-gradient-to-br from-primary-200 to-dark-primary-500 opacity-90 sm:-bottom-6 sm:-end-6" />

                        {/* Brand panel */}
                        <div className="group relative isolate aspect-[4/3] overflow-hidden rounded-3xl bg-gradient-to-br from-primary-900 via-dark-primary-700 to-dark-primary-500 shadow-card-hover lg:aspect-square">
                            {/* texture + glow */}
                            <div aria-hidden className="bg-dots absolute inset-0 -z-10 text-white/[0.08]" />
                            <div aria-hidden className="absolute left-1/2 top-1/2 -z-10 h-3/4 w-3/4 -translate-x-1/2 -translate-y-1/2 rounded-full bg-primary-400/40 blur-3xl" />

                            {/* concentric rings */}
                            <div aria-hidden className="absolute left-1/2 top-1/2 -z-10 aspect-square w-[88%] -translate-x-1/2 -translate-y-1/2 rounded-full border border-white/[0.07]" />
                            <div aria-hidden className="absolute left-1/2 top-1/2 -z-10 aspect-square w-[68%] -translate-x-1/2 -translate-y-1/2 animate-[spin_40s_linear_infinite] rounded-full border border-dashed border-white/20" />
                            <div aria-hidden className="absolute left-1/2 top-1/2 -z-10 aspect-square w-[48%] -translate-x-1/2 -translate-y-1/2 rounded-full border border-white/10 bg-white/[0.04]" />

                            {/* electric pulse running through the panel, echoing the mark */}
                            <svg aria-hidden viewBox="0 0 400 100" preserveAspectRatio="none" className="absolute inset-x-0 top-1/2 -z-10 h-1/4 w-full -translate-y-1/2 text-primary-200/40">
                                <path d="M0 55 H120 L140 20 L160 85 L180 40 L195 60 H205 L220 40 L240 85 L260 20 L280 55 H400" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" vectorEffect="non-scaling-stroke" />
                            </svg>

                            {/* the mark */}
                            <div className="absolute inset-0 grid place-items-center pb-10 sm:pb-12">
                                <div className="animate-float">
                                    <BrandMark
                                        title={t("hero.company_name")}
                                        className="w-28 drop-shadow-[0_20px_35px_rgba(6,33,63,.55)] transition-transform duration-700 group-hover:scale-105 sm:w-40 lg:w-48"
                                    />
                                </div>
                            </div>

                            {/* caption */}
                            <div className="absolute inset-x-0 bottom-5 flex justify-center sm:bottom-7">
                                <span className="rounded-full border border-white/15 bg-white/10 px-4 py-1.5 text-xs font-light tracking-[1px] text-primary-50 backdrop-blur-md sm:text-sm">
                                    {t("hero.company_name")}
                                </span>
                            </div>
                        </div>

                        {/* floating badges */}
                        <div className="absolute -bottom-6 start-6 grid h-16 w-16 animate-float place-items-center rounded-2xl bg-white text-dark-primary-500 shadow-card-hover ring-1 ring-primary-50 sm:h-20 sm:w-20">
                            <TbShieldCheck className="h-8 w-8 sm:h-10 sm:w-10" strokeWidth={1.5} />
                        </div>
                        <div className="absolute -top-5 end-8 grid h-12 w-12 animate-float place-items-center rounded-full bg-primary-400 text-white shadow-glow [animation-delay:1.5s] sm:h-14 sm:w-14">
                            <TbWorld className="h-6 w-6 sm:h-7 sm:w-7" strokeWidth={1.5} />
                        </div>
                    </div>

                    {/* Text */}
                    <div data-aos="fade-up" data-aos-delay="100" className="text-center lg:col-span-7 lg:text-start">
                        <div className="eyebrow mb-3 rtl:mb-4">
                            {t("about.sub_title")}
                        </div>
                        <h2 className="section-title mb-5">
                            {t("about.title")}
                        </h2>
                        <p className="global-p mx-auto max-w-2xl lg:mx-0 lg:max-w-none rtl:leading-[2.375]">
                            {t("about.content")}
                        </p>
                    </div>
                </div>
            </div>
        </Element>
    )
}

export default About;
